/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { GridContainer, CellContainer, GridColumn } from './styled';
import StatusCell from '../status-cell';
import GridHeader from './grid-header';
import { isDefined } from '../../helpers/utils';

const Grid = (props) => {
  const { activities, mappedAssignmentIndexes } = props;

  const sortedStudents = useSelector(
    (state) => state.CourseAssignReducer.sortedStudents,
    shallowEqual
  );

  const datePreference = useSelector(
    (state) =>
      state.CourseAssignReducer?.datePreference?.length > 0
        ? state.CourseAssignReducer?.datePreference
        : [undefined, undefined],
    shallowEqual
  );

  const courseId = useSelector(
    (state) => state.CourseAssignReducer.activeCourseID
  );

  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );

  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);

  const studentAssignments = useSelector(
    (state) => state.CourseAssignReducer.assignments.studentAssignments,
    shallowEqual
  );

  // This is a costly render, lets not do it until all data is available
  const hasLoaded =
    studentAssignments?.length > 0 &&
    isDefined(datePreference) &&
    sortedStudents?.length > 0 &&
    isDefined(courseId) &&
    isDefined(activities) &&
    activities.length &&
    isDefined(classroomId) &&
    isDefined(groupId);

  return (
    <GridContainer>
      <GridHeader
        activities={activities}
        mappedAssignmentIndexes={mappedAssignmentIndexes}
      />
      <CellContainer>
        {hasLoaded &&
          activities.map((activity, activityIndex) => {
            const { activityId, activityName, taskType } = activity;
            /* eslint-disable react/jsx-indent */
            /* eslint-disable prettier/prettier */
            return (
              <GridColumn key={`${activityId}_${taskType}`}>
                {mappedAssignmentIndexes?.[activityName].map((index) => {
                  const currentStudent = studentAssignments[index];
                  return <StatusCell
                    i18n={props.i18n}
                    activityName={activity.activityName}
                    isFiltered={currentStudent.isFiltered || false}
                    currentStudent={currentStudent.student}
                    key={`${activityId}_${activityIndex}_${currentStudent.encryptedUserProfileId}`}
                    studentInfo={currentStudent}
                    index={index}
                    datePreference={datePreference}
                    courseId={courseId}
                    classroomId={classroomId}
                    groupId={groupId}
                  />
                })}
              </GridColumn>
            );
            /* eslint-enable react/jsx-indent */
            /* eslint-enable prettier/prettier */
          })}
      </CellContainer>
    </GridContainer>
  );
};

Grid.propTypes = {
  i18n: PropTypes.object,
  activities: PropTypes.array,
  mappedAssignmentIndexes: PropTypes.object.isRequired
};

Grid.whyDidYouRender = false;

export default Grid;



// WEBPACK FOOTER //
// ./components/grid/index.js